export default {
  data () {
    return {
      publicFieldType1: 'password',
      publicFieldType2: 'password'
    }
  },
  methods: {
    publicToggleType (type) {
      if (type === 'NEW_PWD') {
        if (this.publicFieldType1 === 'password') {
          this.publicFieldType1 = 'text'
        } else {
          this.publicFieldType1 = 'password'
        }
      } else if (type === 'CONFIRM_PWD') {
        if (this.publicFieldType2 === 'password') {
          this.publicFieldType2 = 'text'
        } else {
          this.publicFieldType2 = 'password'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getters/config-password.js